<template>
<div
    class="form-submission-card--header"
    :class="hide_underline ? 'border-0' : ''"
>
    <div
        v-if="title_line_1_computed"
        class="form-submission-card--header-title"
    >
        {{ title_line_1_computed }}
    </div>
    <div
        class="form-submission-card--header-subtitle"
        v-bind:class="form_status?.class"
    >
        {{ title_line_2_computed }}
    </div>
</div>
</template>

<script>
export default {
    props: {
        form_status: Object,
        hide_underline: Boolean,
        title_line_1: String,
        title_line_2: String,
    },
    computed: {
        title_line_1_computed() {
            return this.title_line_1 ?? this.form_status?.title_line_1 ?? '';
        },
        title_line_2_computed() {
            return this.title_line_2 ?? this.form_status?.title_line_2 ?? '';
        },
    }
};
</script>
